<template>
    <div class="profile page">
        <h3 class="page-description">Passion for building modern, simple applications that are purposeful and help businesses to grow.</h3>
        <h2 class="sub-header">Core Skills</h2>
        <div class="skills-wrapper">
            <div class="skill-container">
                <img class="logo" src="../assets/images/profile/logo-javascript.svg"/>
                <span class="language">Javascript</span>
            </div>
            <div class="skill-container">
                <img class="logo" src="../assets/images/profile/logo-html.svg"/>
                <span class="language">HTML</span>
            </div>
            <div class="skill-container">
                <img class="logo" src="../assets/images/profile/logo-css.svg"/>
                <span class="language">CSS</span>
            </div>
            <div class="skill-container">
                <img class="logo" src="../assets/images/profile/logo-vuejs.svg"/>
                <span class="language">Vue</span>
            </div>
            <div class="skill-container">
                <img class="logo" src="../assets/images/profile/logo-nodejs.svg"/>
                <span class="language">Node</span>
            </div>
            <div class="skill-container">
                <img class="logo" src="../assets/images/profile/logo-mongodb.svg"/>
                <span class="language">MongoDB</span>
            </div>
        </div>
        <router-link class="button button-blue" :to="{ name: 'Projects' }">
            View Projects
        </router-link>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Profile',
    methods: {
        ...mapActions(['showMenu', 'showFooter']),
    },
    created() {
        this.showMenu();
        this.showFooter();
    }
}
</script>

<style scoped>
p {
    font-family: lato-light;
    font-size: 0.9em;
    margin: 0;
}
.profile {
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}
.sub-header {
    align-self: center;
    margin: 0;
    margin-top: 10px;
    text-transform: uppercase;
    font-family: lato-extra-bold;
    font-size: 1.2em;
    margin-bottom: 20px;
    color: var(--light-blue)
}
.skills-wrapper {
    align-self: center;
}
.skill-container {
    margin-bottom: 30px;
    display: flex;
}
.logo {
    align-self: flex-start;
    width: 50px;
    height: 50px;
}
.language {
    align-self: center;
    margin-left: 10px;
    font-size: 22px;
    font-family: lato-extra-bold;
}
.button-blue {
    align-self: center;
    margin: 20px 0;
}

@media (min-width: 1024px) {
    .sub-header {
        font-size: 1.3em;
        margin-bottom: 40px;
    }
    .skills-wrapper {
        display: flex;
        flex-flow: row wrap; 
        justify-content: space-evenly;
    }
    .skill-container {
        width: 210px;
        flex: 1 1 auto;
    }
    .logo {
        width: 80px;
        height: 80px;
    }
    .language {
        font-size: 1.6em;
        margin-left: 20px;
    }
}
@media (min-width: 1366px) {
    .skill-container {
        width: 260px;
    }
    .logo {
        width: 90px;
        height: 90px;
    }
    .language {
        font-size: 1.7em;
    }
}
@media (min-width: 1920px) {
    .sub-header {
        font-size: 1.6em;
    }
    .skills-wrapper {
        width: 700px;
        padding-left: 120px;
    }
    .skill-container {
        margin-bottom: 60px;
        width: 350px;
    }
    .logo {
        width: 90px;
        height: 90px;
    }
    .language {
        font-size: 1.8em;
    }
}    
</style>